import {
    CUSTOM_LEAD_LIST_KEY,
    DEFAULT_LEAD_LIST_KEY,
    SETTING_PRIORITY_MIN,
    getPredefinedLeadListByKey,
} from "@/constants/lead-lists.constants";
import { LeadListFilter } from "@/types/lead-list-filter.types";
import { SettingListConfig } from "@/types/setting-list-config.types";

import { resolveListsListKey } from "./setting-list-config.utils";

export { resolveListsListKey } from "./setting-list-config.utils";

const resolveCustomStatuses = (statuses: string[]): string[] | undefined => {
    const filteredStatuses = statuses.filter((status) => status !== "-None-");
    return filteredStatuses.length ? filteredStatuses : undefined;
};

export const resolveLeadListFilterFromConfig = (config: SettingListConfig): LeadListFilter | null => {
    const listKey = resolveListsListKey(config.selectedListKey);

    if (listKey === CUSTOM_LEAD_LIST_KEY) {
        if (!config.customLanguages.length) {
            return null;
        }

        return {
            languages: config.customLanguages,
            layouts: config.customLayouts.length ? config.customLayouts : undefined,
            statuses: resolveCustomStatuses(config.customStatuses),
            settingPriorityMin: config.customSettingPriorityMin,
            settingPriorityMax: config.customSettingPriorityMax,
        };
    }

    const predefinedList = getPredefinedLeadListByKey(listKey);
    const baseFilter = predefinedList?.filter ?? getPredefinedLeadListByKey(DEFAULT_LEAD_LIST_KEY)?.filter;

    if (!baseFilter) {
        return { languages: ["DE"], layouts: ["HT", "HP"] };
    }

    return baseFilter;
};

export const getLeadListFilterKey = (filter: LeadListFilter): string => {
    const layoutsKey = filter.layouts?.length ? filter.layouts.join(",") : "all";
    const statusesKey = filter.statuses?.length ? filter.statuses.join(",") : "all";
    const priorityKey = `${filter.settingPriorityMin ?? "min"}-${filter.settingPriorityMax ?? "max"}`;

    return `${filter.languages.join(",")}:${layoutsKey}:${statusesKey}:${priorityKey}`;
};

export const getFilterSummaryLabels = (filter: LeadListFilter): string[] => {
    const labels: string[] = [filter.languages.join(", ")];

    if (filter.layouts?.length) {
        labels.push(filter.layouts.join(", "));
    }

    if (filter.statuses?.length) {
        labels.push(filter.statuses.join(", "));
    }

    if (filter.settingPriorityMin !== undefined || filter.settingPriorityMax !== undefined) {
        labels.push(`${filter.settingPriorityMin ?? SETTING_PRIORITY_MIN}-${filter.settingPriorityMax ?? "∞"}`);
    }

    return labels;
};
